import { ErrorLike } from '@apollo/client'
import { Center, Spinner } from '@chakra-ui/react'
import { Paragraph } from '@src/components/sco/Paragraph'
import { ReactNode } from 'react'

type AdvisorsQueryStateProps = {
  loading?: boolean
  error?: ErrorLike
  children: ReactNode
}

export const AdvisorsQueryState = ({ loading, error, children }: AdvisorsQueryStateProps) => {
  if (loading) {
    return (
      <Center flex={1} padding={6} width={'full'}>
        <Spinner />
      </Center>
    )
  }

  if (error) {
    return (
      <Center flex={1} padding={6} width={'full'}>
        <Paragraph textAlign={'center'}>Error: {error.message}</Paragraph>
      </Center>
    )
  }

  return <>{children}</>
}
